import { render } from "./ResetPasswordPage.vue?vue&type=template&id=3aa4a1de&scoped=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=3aa4a1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa4a1de"]])

export default __exports__